// import React, { useEffect, useState } from "react";
// import { Card, Spin, Progress, message, Tooltip, Row, Col, Empty } from "antd";
// import { BarChartOutlined, CheckCircleOutlined, ExperimentOutlined } from "@ant-design/icons";
// import courseService from "../../services/course.service";

// const TotalPourcentageViewer = ({ courseId }) => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const fetchData = async () => {
//       if (!courseId) return;
//       setLoading(true);

//       try {
//         const result = await courseService.getTotalPourcentage(courseId);
//         // alert("data is : " + JSON.stringify(result) )
//         setData(result);
//       } catch (err) {
//         message.error("Impossible de récupérer les données de pourcentage");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [courseId]);

//   if (!data || data.length === 0) {
//     return <Empty description="Aucune donnée disponible" />;
//   }

//   const icons = {
//     controle: <CheckCircleOutlined style={{ color: "#1890ff", fontSize: 22 }} />,
//     evaluation: <ExperimentOutlined style={{ color: "#fa8c16", fontSize: 22 }} />,
//     training: <BarChartOutlined style={{ color: "#52c41a", fontSize: 22 }} />,
//     TOTAL: <BarChartOutlined style={{ color: "#722ed1", fontSize: 22 }} />,
//   };

//   return (
//     <Card
//       title="Progression par Type"
//       bordered={false}
//       style={{
//         maxWidth: 450,
//         background: "#f0f5ff",
//         borderRadius: 12,
//         boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//       }}
//     >
//       <Spin spinning={loading}>
//         {data.map((item, index) => (
//           <Row
//             key={index}
//             style={{
//               marginBottom: 15,
//               background: "#fff",
//               padding: 10,
//               borderRadius: 8,
//               boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
//             }}
//             align="middle"
//           >
//             <Col span={3}>{icons[item.type.toLowerCase()]}</Col>
//             <Col span={15}>
//               <Tooltip title={`Progression totale en ${item.type}`}>
//                 <strong>{item.type}</strong>
//               </Tooltip>
//               <Progress
//                 percent={item.totalPourcentage}
//                 status={item.totalPourcentage >= 70 ? "success" : "active"}
//                 strokeColor={
//                   item.type === "controle"
//                     ? "#1890ff"
//                     : item.type === "evaluation"
//                     ? "#fa8c16"
//                     : item.type === "training"
//                     ? "#52c41a"
//                     : "#722ed1"
//                 }
//               />
//             </Col>
//             <Col span={6} style={{ textAlign: "right", fontWeight: "bold" }}>
//               {item.totalPourcentage.toFixed(2)}%
//             </Col>
//           </Row>
//         ))}
//       </Spin>
//     </Card>
//   );
// };

// export default TotalPourcentageViewer;
import React, { useEffect, useState } from "react";
import { Card, Spin, Progress, message, Tooltip, Row, Col, Empty } from "antd";
import { BarChartOutlined, CheckCircleOutlined, ExperimentOutlined } from "@ant-design/icons";
import courseService from "../../services/course.service";

const TotalPourcentageViewer = ({ courseId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ Démarre en mode chargement

  useEffect(() => {
    const fetchData = async () => {
      if (!courseId) return;
      setLoading(true);

      try {
        const result = await courseService.getTotalPourcentage(courseId);
        setData(result);
      } catch (err) {
        message.error("Impossible de récupérer les données de pourcentage");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [courseId]);

  const icons = {
    controle: <CheckCircleOutlined style={{ color: "#1890ff", fontSize: 22 }} />,
    evaluation: <ExperimentOutlined style={{ color: "#fa8c16", fontSize: 22 }} />,
    training: <BarChartOutlined style={{ color: "#52c41a", fontSize: 22 }} />,
    TOTAL: <BarChartOutlined style={{ color: "#722ed1", fontSize: 22 }} />,
  };

  return (
    <Card
      title="Progression par Type"
      bordered={false}
      style={{
        maxWidth: 450,
        background: "#f0f5ff",
        borderRadius: 12,
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        minHeight: 250, // ✅ Garde une hauteur fixe même en attente
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      }}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: "50px 0" }}>
          <Spin size="large" />
        </div>
      ) : !data || data.length === 0 ? (
        <Empty description="Aucune donnée disponible" />
      ) : (
        data.map((item, index) => (
          <Row
            key={index}
            style={{
              marginBottom: 15,
              background: "#fff",
              padding: 10,
              borderRadius: 8,
              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
            }}
            align="middle"
          >
            <Col span={3}>{icons[item.type.toLowerCase()]}</Col>
            <Col span={15}>
              <Tooltip title={`Progression totale en ${item.type}`}>
                <strong>{item.type}</strong>
              </Tooltip>
              <Progress
                percent={item.totalPourcentage}
                status={item.totalPourcentage >= 70 ? "success" : "active"}
                strokeColor={
                  item.type === "controle"
                    ? "#1890ff"
                    : item.type === "evaluation"
                    ? "#fa8c16"
                    : item.type === "training"
                    ? "#52c41a"
                    : "#722ed1"
                }
              />
            </Col>
            <Col span={6} style={{ textAlign: "right", fontWeight: "bold" }}>
              {item.totalPourcentage.toFixed(2)}%
            </Col>
          </Row>
        ))
      )}
    </Card>
  );
};

export default TotalPourcentageViewer;
